module.exports = __webpack_public_path__ + "applications.png?1924fbc7b6a2a1891ad2145f8784f213";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/applications.png
// module id = 20
// module chunks = 0